import { getAnalytics, logEvent as gaLogEvent } from 'firebase/analytics';

export const trackEvent = (eventName, params = {}) => {
  const analytics = getAnalytics();
  gaLogEvent(analytics, eventName, {
    ...params,
    channel: 'web',
  });
};
